const Spacer = ({ height = "1rem" }) => {
    return <div style={{ height }} />;
  };
  
  export default Spacer;
  